import { KeyOutlined, PlusOutlined } from '@ant-design/icons';
import { useGetUserTokensQuery, useRevokeUserTokenMutation } from '@app/services';
import type { ApiKey } from '@mp-pro/shared/interfaces';
import ApiKeyList from '@pages/AppPage/ApiKeyManagement/ApiKeyList';
import { Button, Space, Typography } from 'antd';
import { useState } from 'react';
import AccountStyles from '../Account/Styles.module.scss';
import CreateTokenModal from './CreateTokenModal';

const { Text } = Typography;

export default function ApiTokensSettings() {
    const [showCreate, setShowCreate] = useState(false);
    const { data: tokens = [], isLoading } = useGetUserTokensQuery();
    const [revokeToken, { isLoading: revoking }] = useRevokeUserTokenMutation();

    // Reuse the app API key table; it has the same columns under other names.
    const rows: ApiKey[] = tokens.map(t => ({
        id: t.id,
        name: t.name,
        keyPrefix: t.tokenPrefix,
        createdAt: t.createdAt,
        lastUsedAt: t.lastUsedAt ?? undefined,
        expiresAt: t.expiresAt ?? undefined,
        revokedAt: t.revokedAt ?? undefined,
    }));

    return (
        <div>
            <h1 className={AccountStyles.Title}>API Tokens</h1>
            <Space direction="vertical" style={{ width: '100%' }} size="middle">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
                    <Space align="start">
                        <KeyOutlined style={{ marginTop: 4 }} />
                        <Text type="secondary">
                            Personal tokens let the <code>modelpark</code> CLI and your scripts act as you. They don't expire unless you set a date.
                            Revoke a token to stop it right away.
                        </Text>
                    </Space>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowCreate(true)}>
                        Create Token
                    </Button>
                </div>
                <ApiKeyList keys={rows} loading={isLoading} onRevoke={id => revokeToken(id)} revoking={revoking} />
            </Space>
            <CreateTokenModal open={showCreate} onClose={() => setShowCreate(false)} />
        </div>
    );
}
